export default {
    title: 'Your results',
    text: 'To get your results, enter your contact details and let\'s stay in touch!',
    acceptation: 'I agree to subscribe to the newsletter',
    spam: 'No spam or junk mail, your email address will only be used for the newsletter and quiz results',
    sentByEmail: 'If you want more information, feel free to book a consultation below.',
    introduction: 'Your body and its symptoms teach us a lot.\n' +
        'If you have completed my hormonal health quiz, there\'s a strong chance you are experiencing hormonal imbalances that you\'re trying to understand. You\'re in the right place!\n' +
        'My goal is to help you better understand what your symptoms indicate and provide you with keys to begin rebalancing your hormones naturally.',
    maxNumberOfResults: 1,
    noSymptom: {
        text: 'Congratulations, you don\'t seem to have enough symptoms, you are well balanced hormonally!',
        family: 'Not enough symptoms',
        icon: 'mdi-heart',
    },
    littleSymptoms: {
        text: 'so this category is unlikely to be a culprit in the symptoms you’re experiencing.',
        icon: 'mdi-emoticon-happy',
    },
    mediumSymptoms: {
        text: 'so this area needs your attention because this hormone is probably responsible for some of your symptoms.',
        icon: 'mdi-emoticon-neutral',
    },
    heavySymptoms: {
        text: 'so this just might be your troublemaker, meaning right now this is likely the dominant hormone aggravating your symptoms.',
        icon: 'mdi-emoticon-sad',
    },
    actions: {
        name: {
            text: 'Firstname & Lastname',
            type: 'text',
            color: 'white',
            icon: 'mdi-account-circle',
        },
        email: {
            text: 'Email',
            type: 'email',
            color: 'white',
            icon: 'mdi-email',
        },
        submit: {
            text: 'Get my results',
            type: 'text',
            color: 'white',
        },
        buttons: [{
            text: 'Book a consultation',
            type: 'button',
            color: 'white',
            url: 'https://docs.google.com/forms/d/144Aw8IivNJy93mtZxk1uR0UFJSATQP4t0Z3kELsxQcg/viewform',
        },],
    },
};
